import store from '@/store'

let baseUrl
let sasTokenString

export default {
  init () {
    baseUrl = !baseUrl ? store.getters.book.assetBaseUrl : baseUrl
    sasTokenString = !sasTokenString ? store.getters.book.sasTokenString : sasTokenString
  },
  getPreviewUrl (path, type) {
    this.init()
    return `${baseUrl}${path}${type}${sasTokenString}`
  },
  getStreamUrl (path) {
    this.init()
    return `${baseUrl}${path}${sasTokenString}`
  }
}
